import React, { memo } from "react";
import Tooltip from "rc-tooltip";
import { Info } from "react-feather";
import { FormattedDate, useIntl } from "react-intl";

const CriteriaList = memo(({ availableCriteria, criteriaType }) => {
  const { formatMessage } = useIntl();

  const criteriasAccepted = criteriaType === 'pessoa'
    ? [criteriaType, 'pessoa_fisica']
    : [criteriaType];
  
  const renderedCriteria = availableCriteria.filter(
    criterion => criteriasAccepted.includes(criterion.B3Criterio.tipo_entrada)
  );

  if (!renderedCriteria.length) return null;

  return (
    <div className="new-analysis__criteria-list">
      <div className="available-criteria-title">
        {formatMessage({ id: "bases-disponiveis" })}:
      </div>
      <ul>
        {renderedCriteria.map(criterion => (
          <li key={criterion.B3Criterio.id} className="criteria-line">
            {criterion.B3Criterio.nome}
            {criterion.B3Criterio.descricao &&
              criterion.B3Criterio.descricao.length > 0 && (
                <Tooltip
                  placement="right"
                  trigger={["click", "hover"]}
                  overlay={
                    <>
                      <div>
                        <span className="bold">
                          {formatMessage({ id: "descricao" })}:{" "}
                        </span>
                        {criterion.B3Criterio.descricao}
                      </div>
                      <div>
                        <span className="bold">
                          {formatMessage({ id: "fonte" })}:{" "}
                        </span>
                        {criterion.B3Criterio.fonte}
                      </div>
                      <div>
                        <span className="bold">
                          {formatMessage({ id: "data-base" })}:{" "}
                        </span>
                        <FormattedDate
                          value={new Date(criterion.B3CriterioVersao[0].data)}
                        />
                      </div>
                    </>
                  }
                >
                  <span className="info-indicator">
                    <Info size="14px" />
                  </span>
                </Tooltip>
              )}
          </li>
        ))}
      </ul>
    </div>
  );
});

export default CriteriaList;
